import React, { useState } from 'react';
import { adminService } from '../services/adminService';

const ApiTest = () => {
  const [testResult, setTestResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testApiConnection = async () => {
    setLoading(true);
    try {
      // Test a simple endpoint
      const response = await fetch('https://apitest.pairpinnacle.com/api/v1/admin/users');
      if (response.ok) {
        const data = await response.json();
        setTestResult(`✅ API connection successful! Backend is reachable. Response: ${JSON.stringify(data).substring(0, 100)}...`);
      } else {
        setTestResult(`❌ API responded with status: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      setTestResult(`❌ API connection failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testAdminService = async () => {
    setLoading(true);
    try {
      const users = await adminService.getUsers();
      setTestResult(`✅ Admin service working! Found ${users.length} users.`);
    } catch (error) {
      setTestResult(`❌ Admin service failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testAuthEndpoint = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://apitest.pairpinnacle.com/api/v1/auth/admin-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: 'test@example.com',
          password: 'test123'
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        setTestResult(`✅ Auth endpoint working! Response: ${JSON.stringify(data).substring(0, 100)}...`);
      } else {
        const errorData = await response.json().catch(() => ({}));
        setTestResult(`❌ Auth endpoint failed: ${response.status} - ${JSON.stringify(errorData)}`);
      }
    } catch (error) {
      setTestResult(`❌ Auth endpoint failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-6 max-w-md mx-auto">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">API Connection Test</h3>
      
      <div className="space-y-4">
        <button
          onClick={testApiConnection}
          disabled={loading}
          className="btn-primary w-full"
        >
          {loading ? 'Testing...' : 'Test Basic API Connection'}
        </button>
        
        <button
          onClick={testAdminService}
          disabled={loading}
          className="btn-secondary w-full"
        >
          {loading ? 'Testing...' : 'Test Admin Service'}
        </button>
        
        <button
          onClick={testAuthEndpoint}
          disabled={loading}
          className="btn-secondary w-full"
        >
          {loading ? 'Testing...' : 'Test Auth Endpoint'}
        </button>
        
        {testResult && (
          <div className="mt-4 p-3 bg-gray-100 rounded-lg">
            <p className="text-sm">{testResult}</p>
          </div>
        )}
      </div>
      
      <div className="mt-4 text-xs text-gray-500">
        <p>Base URL: https://apitest.pairpinnacle.com/api/v1</p>
        <p>Connected to hosted backend</p>
      </div>
    </div>
  );
};

export default ApiTest;
